// left-nav-toggle.ts
// Mounts a click handler on the <ul class="left-nav" data-mount="left-nav"> element
// so that only one mega‑menu stays open at a time.
// -----------------------------------------------------------------------------
// USAGE (Blade/HTML) :
// <ul class="nav left-nav d-none d-xl-flex" data-mount="left-nav">
//     ...
// </ul>
// The TS will automatically attach when the bundle executes.
// -----------------------------------------------------------------------------

function mountLeftNav(root: HTMLElement) {
    const triggers = Array.from(root.querySelectorAll<HTMLElement>(
        '.categories-item > .nav-link'
    ));

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            const parent = trigger.closest<HTMLElement>('.categories-item');
            if (!parent) return;

            // Close every other open mega‑nav
            root.querySelectorAll<HTMLElement>('.categories-item.open').forEach((item) => {
                if (item !== parent) item.classList.remove('open');
            });

            // Toggle the clicked one
            parent.classList.toggle('open');
        });
    });
}

// Auto‑mount on DOMContentLoaded
if (document.readyState !== 'loading') {
    document.querySelectorAll<HTMLElement>('[data-mount="left-nav"]').forEach((el) =>
        mountLeftNav(el)
    );
} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll<HTMLElement>('[data-mount="left-nav"]').forEach((el) =>
            mountLeftNav(el)
        );
    });
}

export {};
